import { getConditionalObject } from 'utils/data';

export const getSummaryCardStyles = ({ isClickable, isNotActive }) => ({
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: ({ shape }) => shape.radius.l,
  padding: '4px 8px',
  transition: 'background-color 0.2s ease',

  ...getConditionalObject(isClickable, {
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: ({ palette }) => palette.background.hoverDefault,
    },
  }),

  ...getConditionalObject(isNotActive, {
    backgroundColor: ({ palette }) => palette.background.secondary,

    '& .text-value': {
      color: 'text.secondary',
    },
  }),
});
